import type React from "react";
import { forwardRef } from "react";
import styles from "./backDrop.module.scss";
import { CSSTransition } from "react-transition-group";

import clsx from "clsx";

export interface BackDropProps {
  open: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  children?: JSX.Element | JSX.Element[];
  unmountOnExit?: boolean;
}

const BackDrop = forwardRef<HTMLDivElement, BackDropProps>(
  (props: BackDropProps, ref) => {
    const { open, className, children, unmountOnExit = false, onClick } = props;

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (
        onClick &&
        (event.key === "Enter" || event.key === " " || event.key === "Escape")
      ) {
        event.preventDefault();
        onClick(event as unknown as React.MouseEvent<HTMLDivElement>);
      }
    };

    return (
      <CSSTransition
        in={open}
        timeout={{ enter: 0, exit: 300 }}
        classNames={{
          enterDone: styles["back-drop--enter-done"],
          exit: styles["back-drop--exit"]
        }}
        unmountOnExit={unmountOnExit}
      >
        {/* Backdrop must be a div container for children, cannot use native button element.
            Accessibility: role="button", keyboard support (Enter/Space/Escape), tabIndex, and aria-label are provided. */}
        <div
          ref={ref}
          className={clsx(styles["back-drop"], className)}
          onClick={onClick}
          onKeyDown={handleKeyDown}
          role={onClick ? "button" : undefined}
          // tabIndex={open && onClick ? 0 : -1}
          aria-label={onClick ? "Close modal" : undefined}
        >
          {children}
        </div>
      </CSSTransition>
    );
  }
);

BackDrop.displayName = "BackDrop";

export default BackDrop;
